/**
 * Top level Module for action groups
 * Created by jacmai on 2/24/2017.
 */

define([
  "marionette",
  "backbone",
  "jquery",
  "configuration/properties",
  "messaging/messenger",
  "modules/actions/actionsView",
  "modules/actions/actionList/actionListModule",
  "modules/actions/actionGroup/actionGroupModule",
  "modules/actions/actionsModel",
], function (
  Marionette,
  Backbone,
  $,
  Properties,
  Messenger,
  ActionsView,
  ActionListModule,
  ActionGroupModule,
) {
  "use strict";

  const Router = Marionette.AppRouter.extend({
    appRoutes: {
      ":kbId/actions": "_route",
    },
  });

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "actions";
      this.region = options.region;
      this._setUpVents();
      this._setUpReqres();
      this.router = new Router({
        controller: this,
      });
    },
    show: function () {
      const kbId = Messenger.reqres.request("active:kb");
      Backbone.history.navigate(kbId + "/actions");
      document.title = $.t("menuBar.actions") + " - " + Properties.applicationName;
      this.groups = Messenger.reqres.request("action:groups");
      //save code
      Messenger.onSave(function () {
        console.log("actions onSave");
        this.groups.saveCollection();
      }, this);
      //load the apis and variables so that we can create our own handler
      this.apis = Messenger.reqres.request("apis");
      this.variables = Messenger.reqres.request("conversation:variables");
      this.allVariables = Messenger.reqres.request("all:variables");

      this.layout = new ActionsView.actionsLayout();
      this.actionGroupsList = this.addSubModule(
        new ActionListModule({ region: this.layout.actionGroupsList }),
      );
      this.actionGroup = this.addSubModule(
        new ActionGroupModule({ region: this.layout.actionGroup }),
      );

      this.layout.on(
        "add:group",
        function () {
          Messenger.save(function (success) {
            if (success) {
              const newGroup = this.groups.addGroup();
              this.actionGroupsList.selectItem(newGroup);
            }
          }, this);
        },
        this,
      );

      this.layout.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );

      this.showRegion(this.layout);
    },
    _showSubViews: function () {
      this.actionGroupsList.show(this.groups);
    },
    _route: function (kbId) {
      const isAuthor = Messenger.reqres.request("user:is:author", kbId);
      if (!isAuthor) {
        Backbone.history.navigate("", { trigger: true });
        return;
      }
      Messenger.command.execute("set:active:kb", kbId);
      Messenger.command.execute("change:menu", "actions");
      this.show();
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:actions",
        function () {
          this.show();
        },
        this,
      );
      Messenger.vent.on(
        "show:action:group",
        function (actionGroup) {
          Messenger.command.execute("change:menu", "actions");
          this.show();
          this.actionGroupsList.selectItem(actionGroup);
        },
        this,
      );
    },
    _setUpReqres: function () {
      //Create Action Module reqres' for apis and variables so that child modules do not need to
      //load this data over and over again
      Messenger.reqres.setHandler(
        "action:apis",
        function () {
          return this.apis;
        },
        this,
      );

      Messenger.reqres.setHandler(
        "action:variables",
        function () {
          return this.variables;
        },
        this,
      );

      Messenger.reqres.setHandler(
        "action:all:variables",
        function () {
          return this.allVariables;
        },
        this,
      );
    },
  });
});
